"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.logErrorMessage = void 0;
/* global console */
/**
 * Logs an error message
 * @param err The error to be logged
 */
function logErrorMessage(err) {
    console.error(`Error: ${err instanceof Error ? err.message : err}`);
}
exports.logErrorMessage = logErrorMessage;
//# sourceMappingURL=log.js.map